import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import liveConsoleActions from '@/state/actions/liveConsoleActions';
import mainActions from '@/state/actions/mainActions';
import profilEditActions from '@/state/actions/profileEditActions';
import signUpActions from '@/state/actions/signUpActions';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  modules,
  actions: {
    ...liveConsoleActions,
    ...mainActions,
    ...profilEditActions,
    ...signUpActions
  }
});

export default store;
